// extracted by mini-css-extract-plugin
export var brandPrimary = "index-module--brandPrimary--3a268";
export var counter = "index-module--counter--b8956";
export var critical = "index-module--critical--7b638";
export var secondary = "index-module--secondary--96ef6";